import LogRocket from 'logrocket';

const logRocketId = import.meta.env.VITE_APP_LOGROCKET_ID;

export const initLogRocket = () => {
  console.log('Initialize log rocket for app');
  if (logRocketId && logRocketId !== '') {
    LogRocket.init('software-defined-automation/phoenix');
  }
};
